var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable lines-around-comment */
/* eslint-disable require-jsdoc */
import React, { useEffect } from 'react';
import { useSocket } from "../socket-io/SocketContext";
//@ts-ignore
import { createInviteDialogEvent, createToolbarEvent, sendAnalytics } from "../analytics";
// @ts-ignore
import { NOTIFICATION_TIMEOUT, showNotification } from "../notifications";
//@ts-ignore
import { jitsiLocalStorage } from "lib-js-utils";
//@ts-ignore
import { invite } from '../invite';
//@ts-ignore
import { getInviteTypeCounts } from "../invite";
import { useDispatch } from "react-redux";
const PhoneCallback = () => {
    const { lastMessage } = useSocket();
    const dispatch = useDispatch();
    const callbackPhone = (phone, room) => __awaiter(void 0, void 0, void 0, function* () {
        console.log('call to other phone number', phone);
        sendAnalytics(createToolbarEvent('call phone number'));
        try {
            const invitees = [
                {
                    allowed: true,
                    country: '',
                    number: phone,
                    originalEntry: phone,
                    showCountryCodeReminder: false,
                    type: 'phone',
                    codecName: phone,
                    roomCode: room,
                    name: phone
                }
            ];
            // @ts-ignore
            const jitsiInvitees = {
                filterValues: [`${phone}`, `${phone}`],
                content: `${phone}`,
                description: '',
                isDisabled: false,
                address: '',
                item: invitees[0],
                value: `${phone}`
            };
            jitsiLocalStorage.setItem('inviteItems', JSON.stringify(jitsiInvitees));
            dispatch(invite(invitees, false, (invitesLeftToSend) => {
                var _a;
                if (invitesLeftToSend.length) {
                    const erroredInviteTypeCounts = getInviteTypeCounts(invitesLeftToSend);
                    sendAnalytics(createInviteDialogEvent('error', 'invite', Object.assign({}, erroredInviteTypeCounts)));
                }
                else {
                    dispatch(showNotification({
                        titleArguments: {
                            name: (_a = invitees[0]) === null || _a === void 0 ? void 0 : _a.name
                        },
                        titleKey: 'notify.callbackStarted'
                    }, NOTIFICATION_TIMEOUT));
                }
            }));
        }
        catch (e) {
            console.log('error', e);
        }
    });
    useEffect(() => {
        if (!lastMessage || (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.type) !== "callback")
            return;
        callbackPhone(lastMessage.fromPhone, lastMessage.roomId).then(() => null);
    }, [lastMessage]);
    return (React.createElement(React.Fragment, null));
};
export default PhoneCallback;
